import * as keyapis_watchdog_v1_events_pb from "./v1/keyapis_watchdog_events_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_watchdog_v1_events_pb,
    },
  },
};
